import { HTMLAttributes, ReactNode } from 'react'

type Props = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode
}

export const Box = ({ children, ...restProps }: Props) => {
  return <div {...restProps}>{children}</div>
}
